var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{ref:"link",attrs:{"href":_vm.url,"target":"_blank"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }